import styled from 'styled-components'

export default styled.div`
  font-family: ${ ({ theme }) => theme.fontFamily };
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  margin-bottom: 35px;
  box-sizing: border-box;
  transition: all ease-in 0.2s;

  label {
    position: absolute;
    left: scale(20);
    background-color: transparent;
    padding: 0;
    font-size: 18px;
    color: ${ ({ theme }) => theme.colors.grey };
    top: 8px;
    z-index: 0;
    transition: ease-in-out all 0.2s;
    cursor: text;
  }

  input {
    font-family: ${ ({ theme }) => theme.fontFamily };
    padding: 9px 0;
    width: 100%;
    font-size: 16px;
    box-sizing: border-box;
    border: none;
    border-bottom: 1px solid ${ ({ theme }) => theme.colors.grey };
    outline: none;
    transition: all ease-in-out 0.1s;
  }

  .password-visibility {
    position: absolute;
    bottom: 12px;
    right: 8px;
    img {
      width: 20px;
      height: 20px;
      display: block;
      cursor: pointer;
    }
  }

  &.filled {
    label {
      color: ${ ({ theme }) => theme.colors.greyDark };
      top: -12px;
      z-index: 1;
      font-size: 12px;
    }
  }

  &.invalid {
    label {
      color: ${ ({ theme }) => theme.colors.red };
    }
    input {
      color: ${ ({ theme }) => theme.colors.red };
      border-bottom-color: ${ ({ theme }) => theme.colors.red };
    }
  }

    /* Chrome, Safari, Edge, Opera */
  input[type=number]::-webkit-outer-spin-button,
  input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }

  .phone-input {
    padding-left: 64px;
  }

  .phone-code-container {
    display: flex;
    flex-direction: row;
    position: absolute;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    z-index: 10;

    .flag-container {
      font-size: 25px;
      cursor: pointer;
    }

    span {
      cursor: pointer;
    }
  }
`
